import React, { Component } from 'react';
import { connect } from 'react-redux';
import {prefix} from '../../../i18n'
import Gamification2026ThankYou from '../../Gamification2026Template/Register/confirm'

const tRegistry = prefix('registry')

const isGamification2026 = (client) => {
  if (!client) return false
  return (client.template.template_type === 'gamification_2026')
}

class ThankYou extends Component{

  constructor(props){
    super(props);
    this.state={}
  }

  render() {
    const client = this.props.client
    if (isGamification2026(client)) {
      return <Gamification2026ThankYou />
    }
    return (

      <div>
         <div className='image-background'  style={client.background_banner.url ? {backgroundImage: 'url(' + client.background_banner.url + ')'}: {} }>
          <div className="row center-lg  font-quicksand center-xs center-md h-screen">
            <div className="col-lg-8 col-md-8 col-xs-11 default-container-login bg-white">
              <h1 className='pt-10 template-title text-center'>{tRegistry('thank-you')}</h1>
              <div className="py-10 mx-8 px-8 my-10  text-left bg-white">
                <p className='template-title text-2xl center'>
                  {tRegistry('thanking-message')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    loggedIn: state.userReducer.loggedIn,
    client: state.userReducer.client
  }
}

export default connect(mapStateToProps,null)(ThankYou);